module.exports = __webpack_public_path__ + "img/cash-on-delivery.5e1382b7.png";